import { Card } from 'components/TeamOverview/components/Common/Card/Card';
import { Avatar, Typography, Box, CircularProgress } from '@mui/material';
import React from 'react';
import logoHighResolutionTile from 'images/logos/logoHighResolutionTile.png';
import { stringAvatar } from 'components/TeamOverview/utilities';
import { useContactsCardStyles } from 'components/TeamOverview/components/ContactsCard/styles';
import { DEFAULT_REPS } from 'components/TeamOverview/constants';

const UserCard = ({ firstName, lastName, email, classes }) => (
  <Box marginBottom={3} display="flex" flexDirection="row" alignItems="center">
    <Avatar {...stringAvatar(firstName, lastName)} />
    <Box marginLeft={1.5}>
      <Typography fontWeight={500} fontSize={'1.125rem'}>
        {firstName} {lastName}
      </Typography>
      <Typography
        fontWeight={400}
        fontSize={'1.125rem'}
        className={classes.email}
      >
        <a href={`mailto:${email}`}>{email}</a>
      </Typography>
    </Box>
  </Box>
);

export const ContactsCard = React.memo(({ team, isLoading }) => {
  const { classes } = useContactsCardStyles();

  const reps = team?.territory_reps?.length
    ? team.territory_reps
    : DEFAULT_REPS;

  return (
    <Card
      cardClass={classes.card}
      header={
        <Box
          paddingY="1rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Typography
            height="max-content"
            fontWeight={500}
            fontSize={'1.125rem'}
          >
            HistoWiz Contact
          </Typography>
          <img
            className={classes.hwLogo}
            src={logoHighResolutionTile}
            alt="HistoWiz Logo"
          />
        </Box>
      }
    >
      <Box paddingX={3} paddingY={2.5}>
        <Typography
          fontWeight={600}
          fontSize={'1.125rem'}
          marginBottom={2}
          position="relative"
        >
          Sales Representative
        </Typography>
        {isLoading ? (
          <Box className={classes.loadingBox}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          reps.map(({ email, first_name, last_name }) => (
            <UserCard
              key={email}
              firstName={first_name}
              lastName={last_name}
              email={email}
              classes={classes}
            />
          ))
        )}
        <Typography fontWeight={600} fontSize={'1.125rem'} marginBottom={2}>
          Account Manager
        </Typography>
        <UserCard
          firstName="Bryce"
          lastName="Li"
          email="bryce@histowiz.com"
          classes={classes}
        />
        <Typography fontWeight={600} fontSize={'1.125rem'} marginBottom={2}>
          Customer Support
        </Typography>
        <Box marginLeft={1.5}>
          <Typography
            fontWeight={400}
            fontSize={'1.125rem'}
            className={classes.email}
          >
            <a href={'mailto:getsupport@histowiz.com'}>
              getsupport@histowiz.com
            </a>
          </Typography>
        </Box>
      </Box>
    </Card>
  );
});

ContactsCard.displayName = 'ContactsCard';
